import logoImage from "@assets/favicon new no background cc6633.png";

export default function MarketingFooter() {
  return (
    <footer className="bg-muted/20 border-t">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <img src={logoImage} alt="Fill The Trucks" className="h-10 mb-4" />
            <p className="text-sm text-muted-foreground">Fill The Trucks — Compare freight bids from your carriers and brokers, all in one place.</p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/how-it-works" className="hover:text-foreground transition-colors" data-testid="link-how-it-works">How It Works</a></li>
              <li><a href="/pricing" className="hover:text-foreground transition-colors" data-testid="link-membership">Membership</a></li>
              <li><a href="/pricing" className="hover:text-foreground transition-colors" data-testid="link-pricing">Pricing</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/support" className="hover:text-foreground transition-colors" data-testid="link-help">Contact Us</a></li>
              <li><a href="/terms-of-use" className="hover:text-foreground transition-colors" data-testid="link-terms">Terms of Use</a></li>
              <li><a href="/privacy-policy" className="hover:text-foreground transition-colors" data-testid="link-privacy-menu">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t text-center text-sm text-muted-foreground">
          <p>&copy; 2026 Fill The Trucks. All rights reserved. | 
            <a href="/privacy-policy" className="hover:text-foreground ml-2" data-testid="link-privacy">Privacy Policy</a> | 
            <a href="/terms-of-use" className="hover:text-foreground ml-2" data-testid="link-terms-footer">Terms of Use</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
